import { useQuery } from '@tanstack/react-query'
import identity from 'lodash/identity'
import React from 'react'

type DataProviderProps = {
  children: (props: any) => React.ReactNode
  name?: any
  transformer?(...args: unknown[]): unknown
  query(...args: unknown[]): unknown
}

export function DataProvider({ children, name, transformer = identity, query }: DataProviderProps) {
  const { isLoading, isError, data: originalData, error, ...rest } = useQuery(name, query)
  let data = originalData

  if (data) data = transformer(data)

  return children({ isLoading, isError, data, error, ...rest })
}
